
import React from 'react';
import { IconProps } from '../../types/types';

const ResetIcon: React.FC<IconProps> = ({ color = '#1E1E1E' }) => (
<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.0472 4.09835C10.431 3.91418 9.75097 3.79376 9.00014 3.79376C5.60722 3.79376 2.85889 6.5421 2.85889 9.93501C2.85889 13.335 5.60722 16.0833 9.00014 16.0833C12.3931 16.0833 15.1414 13.335 15.1414 9.9421C15.1414 8.68126 14.7589 7.50543 14.1072 6.52793" stroke={color} strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M11.9255 4.26832L9.87842 1.91666" stroke={color} strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M11.9257 4.26834L9.53857 6.01084" stroke={color} strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round"/>
</svg>


);

export default ResetIcon;